import { render, staticRenderFns } from "./MoodlePluginDownload.vue?vue&type=template&id=315eebec&scoped=true"
import script from "./MoodlePluginDownload.vue?vue&type=script&lang=js"
export * from "./MoodlePluginDownload.vue?vue&type=script&lang=js"
import style0 from "./MoodlePluginDownload.vue?vue&type=style&index=0&id=315eebec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315eebec",
  null
  
)

export default component.exports